import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { fetchProviderSettingsListRequest, updateProviderSettingsRequest } from './requestHandlers';
import { IProviderSettings, IProviderSettingsListData } from './types';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadProviderSettingsStart = createAction('provider_settings/load/start');
export const loadProviderSettingsListSuccess = createAction<Partial<IProviderSettingsListData>>('providers_settings/load/success');

export const fetchProviderSettingsList = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadProviderSettingsStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });
    const data = await fetchProviderSettingsListRequest(mergedParams);
    if (data) {
      dispatch(loadProviderSettingsListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const updateProviderSettings = async (data: Partial<IProviderSettings>): Promise<Partial<IProviderSettings>> =>
  updateProviderSettingsRequest(data);
